import {request} from '@/util/scripts/request'

const commonSetting = {
  parse: {
    success: 'res.status',
    message: 'res.message',
    result: 'res.data'
  }
}

// const paginationSetting = {
//   pagination: {page: 'page', size: 'num'},
//   parse: Object.assign({}, commonSetting.parse, {
//     size: 'res.data.num',
//     page: 'res.data.page',
//     total: 'res.data.counts',
//     result: 'res.data.list'
//   })
// }

const domain = process.env.VUE_APP_WebCheckServer
export default {

  //1. 根据域名获取对应LDNS解析IP信息
  dns: Object.assign({
    url: domain + '/api/v1.0/domain/ping',
    query: {
      domain: 'params.domain'
    }
  }, commonSetting),

  //2. 获取客户端IP
  clientIP: Object.assign({
    url: domain + '/api/v1.0/domain/getClientIP'
  }, commonSetting),

  //3. 根据GEO坐标获取详细地理位置
  geo: Object.assign({
    url: domain + '/api/v1.0/geo',
    query: {
      location: 'params.location'
    }
  }, commonSetting),

  //4. 域名探测
  probe: Object.assign({
    url: domain + '/api/v1.0/domain/probe',
    query: {
      domain: 'params.domain'
    }
  }, commonSetting),

  //5. 探测数据保存接口
  report(params) {
    console.log('report', JSON.parse(params.reportdata))
    return request(Object.assign({
      url: domain + '/api/v1.0/domain/reportdata',
      data: {
        uuid: 'params.uuid',
        reportdata: 'params.reportdata'
      }
    }, commonSetting), params)
      //.then(({success, result, message}) => console.log('report', success, params))
      .catch(e => null)
  },

  //6. 反馈信息保存接口
  feedback(params) {
    return request(Object.assign({
      url: domain + '/api/v1.0/domain/feedback',
      data: {
        uuid: 'params.uuid',
        username: 'params.name',
        cellphone: 'params.phone',
        qq: 'params.qq',
        wechat: 'params.wechat',
        email: 'params.email',
        desc: 'params.desc'
      }
    }, commonSetting), params)
  }
}